import { useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { setThemeAction } from "../store/ui/actions";
import { ThemeModel } from "../store/ui/state";
import { useRPC } from "./rpc";

export function useChangeTheme(){
    const dispatch = useDispatch();
    const [rpc] = useRPC();
    return {
        setTheme: useCallback((theme: ThemeModel) => {
            rpc.setTheme(theme).then(() => dispatch(setThemeAction(theme)))
        }, [dispatch]),
        theme: useSelector(state => state.ui.theme)
    }
    // const [theme, setTheme] = useLocalStorage<'default' | 'rounded'>('themeForPanel', 'default');
    // return {theme, setTheme}
}
